import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApiHttpService } from 'src/app/core/services/apiHttpcall.service';


@Component({
  selector: 'acv-multiselect',
  templateUrl: './multiselect-dropdown.component.html',
  styleUrls: ['./multiselect-dropdown.component.scss']
})
export class MultiselectDropdownComponent {

  @Input() form: FormGroup;
  @Input() ControlName: string;
  @Input() Options_List:any[];
  @Input() OptionLabel:string = "name";
  @Input() OptionValue:string = "id";
  @Input() Required:boolean;
  @Input() ControlLabelText:string;
  @Input() PlaceHolderText:string = "Enter Here";
  @Input() Filter:boolean = false;
  @Input() selectedItems:any[] = [];
  @Input() IsSubmited:boolean = false;
  @Input() LookupAPI:string = '';
  @Input() IsLoading: boolean = false;


  @Input('selectedItems') set _SelectedItems(value: any) {
    console.log("From child", value);
    
    if(value && value.length > 0){
      setTimeout(() => {
        this.selectedItems = value;

      }, 2000);
    }
  }

  constructor(private cdref: ChangeDetectorRef, private httpService: ApiHttpService) {}

  async reloadLookup() {
    this.IsLoading = true;

    let resp = await this.httpService.get(this.LookupAPI);
    this.IsLoading = false;

    if (resp?.status == 200 || resp?.status == 201) {
      if (resp?.data && resp?.data.length) {
        this.Options_List = [...resp?.data];
        this.cdref.detectChanges();
      }
    }
  }
  
}
